<template>
  <div class="olympicMusicShowGroup">
    <ul>
      <li v-for="item in groups" :key="item.groupId" @click="next(item)">
        <span class="text1">{{item.name}}</span>
        <span class="text2">{{item.viewText}}</span>
      </li>
    </ul>

    <div class="box">
      <div class="button btn3" @click="navToRecords">我的赛程</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'olympicMusicShowGroup',
  computed: {
    competitiontypes: {
      get() {
        return this.$store.state.olympicMusicShow.competitiontypes
      }
    },
    selectCompetitiontype: {
      get() {
        return this.$store.state.olympicMusicShow.selectCompetitiontype
      }
    },
    selectProfessional: {
      get() {
        return this.$store.state.olympicMusicShow.selectProfessional
      }
    },
    competitiontypesName() {
      if (this.selectCompetitiontype) {
        return this.selectCompetitiontype.name
      } else {
        return ''
      }
    },
    groups() {
      if (this.selectProfessional) {
        return this.selectProfessional.groups
      } else {
        return []
      }
    }
  },
  mounted() {
    document.title = this.competitiontypesName
  },
  methods: {
    navToRecords() {
      this.$router.push({ path: "records" });
    },
    next(item) {
      this.$store.commit('olympicMusicShow/setGroup', item)
      this.$store.commit('olympicMusicShow/resetSingleForm')
      this.$store.commit('olympicMusicShow/resetMultiForm')

      if (this.selectCompetitiontype && this.selectCompetitiontype.isSingle) {
        this.$router.push({ path: 'singleRegister', query: { typeId: this.$route.query.typeId, professionalId: this.$route.query.professionalId, groupId: item.groupId } })
      } else {
        this.$router.push({ path: 'multiRegister', query: { typeId: this.$route.query.typeId, professionalId: this.$route.query.professionalId, groupId: item.groupId } })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/css/flexable.scss';

.olympicMusicShowGroup {
  width: 100%;
  min-height: 100vh;
  background-color: #F5F5F9;
  .box {
    .button {
      position: fixed;
      left: 0;
      bottom: 0;
      width: 25vw;
      height: 11.1vw;
      line-height: 11.1vw;
      color: #fff;
      font-size: 13px;
    }
    .btn3 {
      background: url(../../assets/competition_btn3.png) no-repeat;
      background-size: cover;
      bottom: 31.9vw;
    }
  }
  ul {
    padding-top: px2rem(30);
    padding-bottom: px2rem(20);
    li {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      justify-content: center;
      margin-bottom: px2rem(20);
      width: 100%;
      height: px2rem(237);
      padding-left: px2rem(41);
      background-color: #fff;
      box-sizing: border-box;
      &:last-child {
        margin-bottom: 0;
      }
      .text1 {
        margin-bottom: px2rem(30);
        font-size: px2rem(36);
        font-weight: bold;
        color: #585858;
        line-height: 1;
      }
      .text2 {
        font-size: px2rem(26);
        font-weight: 500;
        color: #585858;
        line-height: 1;
      }
    }
  }
}
</style>